import axios from 'axios';
/**
 * Exports a pre-configured instance of axios.
 *
 * Usage:
 * ```
 * import axios from './_axios';
 *
 * const myApiFetch = axios.get('/my-url'); // uses the hereby defined configurations
 * ```
 */
var instance = axios.create({
    baseURL: process.env.API_BASE_URL + "/" + process.env.API_REST_ENDPOINT_PREFIX,
    params: {
        widgetId: process.env.WIDGET_ID,
    },
});
export default instance;
